module.exports = __webpack_public_path__ + "img/1to1-meeting.51bdd5ce.png";